var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":require("../../assets/images/pdf-invoice-logo.svg")},on:{"click":_vm.downloadPDF}})
}
var staticRenderFns = []

export { render, staticRenderFns }